module.exports = __webpack_public_path__ + "static/cvSCA-ab5f062ff838eeb3a17e6ad7d45523cd.pdf";